import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { Seo } from '@/components/seo/Seo';
import { Container } from '@/components/ui/Container';
import { siteConfig } from '@/data/site';
import { usePosts } from '@/hooks/usePosts';

export const SitemapPage = () => {
  const { posts, isLoading } = usePosts();

  const byCategory = posts.reduce<Record<string, typeof posts>>((acc, post) => {
    const cat = post.category || 'Uncategorised';
    (acc[cat] ??= []).push(post);
    return acc;
  }, {});

  return (
    <>
      <Seo title="Sitemap" description={`All posts on ${siteConfig.name}`} path="/sitemap" />
      <Container>
        <section className="section-stack prose-page">
          <div className="section-heading">
            <h1>Sitemap</h1>
          </div>

          <h2>Pages</h2>
          <ul className="prose__ul">
            <li className="prose__li"><Link to="/" className="prose__a">Home</Link></li>
            <li className="prose__li"><Link to="/about" className="prose__a">About</Link></li>
            <li className="prose__li"><Link to="/categories" className="prose__a">Categories</Link></li>
            <li className="prose__li"><Link to="/tags" className="prose__a">Tags</Link></li>
            <li className="prose__li"><Link to="/rss" className="prose__a">RSS Feed</Link></li>
          </ul>

          <h2>Posts</h2>

          {isLoading ? (
            <p>Loading…</p>
          ) : (
            Object.entries(byCategory)
              .sort(([a], [b]) => a.localeCompare(b))
              .map(([category, categoryPosts]) => (
                <div key={category}>
                  <h3>{category}</h3>
                  <ul className="prose__ul">
                    {categoryPosts.map((post) => (
                      <li key={post.slug} className="prose__li">
                        <Link to={`/posts/${post.slug}`} className="prose__a">
                          {post.title}
                        </Link>
                        {post.date && (
                          <span style={{ marginLeft: '0.5rem', opacity: 0.6 }}>
                            — {format(new Date(post.date), 'dd MMM yyyy')}
                          </span>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))
          )}
        </section>
      </Container>
    </>
  );
};
